import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import "moment/locale/zh-tw";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import NavigateNext from "@material-ui/icons/NavigateNext";
import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import Grid from "../../components/Grid";
import Text from "../../components/Text";
import { Card, CardContent } from "../../components/Card";
import Button from "../../components/Button";
import { DateInput, TextInput } from "../../components/Form";
import { useAlert } from "../../components/Alert";
import LoadingModal from "../../components/LoadingModal";

const GET_CALENDARS = gql`
  query calendars($userId: Int!) {
    calendars(userId: $userId) {
      count
      contents {
        id
        date
        content
      }
    }
  }
`;

const GET_CALENDAR = gql`
  query calendar($id: Int!) {
    calendar(id: $id) {
      id
      date
      content
    }
  }
`;

const SAVE_CALENDAR = gql`
  mutation saveCalendar($calendarInput: CalendarInput!) {
    saveCalendar(calendarInput: $calendarInput)
  }
`;

const DELETE_CALENDAR = gql`
  mutation deleteCalendar($id: Int!) {
    deleteCalendar(id: $id)
  }
`;

export let navigate = {
  PREVIOUS: "PREV",
  NEXT: "NEXT",
};

const localizer = momentLocalizer(moment);
let today = new Date();
let y = today.getFullYear();
let m = today.getMonth();
let d = today.getDate();

class CustomToolbar extends React.Component {
  render() {
    let { label } = this.props;
    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            <NavigateBefore fontSize={"small"} />
          </button>
        </span>
        <Text className="rbc-toolbar-label" type="h5">
          {label}
        </Text>
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            <NavigateNext fontSize={"small"} />
          </button>
        </span>
      </div>
    );
  }
  navigate = (action) => {
    this.props.onNavigate(action);
  };
}

export default function PersonalCalendarTable() {
  const Alert = useAlert();
  const [events, setEvents] = useState([]);
  const eventColors = (event) => {
    const backgroundColor = event.color === "default" ? "#16508B" : "#00A7AB";
    var style = {
      backgroundColor: backgroundColor,
      borderRadius: "0px",
      opacity: 0.8,
      color: "white",
      border: "0px",
      display: "block",
    };
    return {
      style: style,
    };
  };
  const [newData, setNewData] = useState({
    open: false,
    detailsOpen: false,
    id: null,
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const { refetch, loading } = useQuery(GET_CALENDARS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      userId: Number(localStorage.getItem("@fullhouseUserId")),
    },
    onCompleted({ calendars }) {
      if (calendars) {
        let newArray = [];
        calendars.contents.map((item) => {
          newArray.push({
            id: item.id,
            title: item.content,
            allDay: true,
            start: item.date,
            end: item.date,
          });
        });
        setEvents(newArray);
      }
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Grid container spacing={1} justify="flex-end">
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onPress={() => {
                  changeData("open", true, true);
                }}
              >
                新增活動
              </Button>
              <CalendarDialog
                id={newData.id}
                open={newData.open}
                onClose={(v) => {
                  if (v === "refetch") refetch();
                  changeData("id", null);
                  changeData("open", false, true);
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <TableContainer>
            <BigCalendar
              localizer={localizer}
              events={events}
              startAccessor="start"
              endAccessor="end"
              style={{
                display: "flex",
                height: "100%",
                minHeight: "100vh",
                width: "100%",
                minWidth: 892,
              }}
              components={{
                toolbar: CustomToolbar,
              }}
              eventPropGetter={eventColors}
              onSelectEvent={(event, i) => {
                changeData("open", true);
                changeData("id", event.id, true);
              }}
            />
          </TableContainer>
        </CardContent>
      </Card>
    );
  }
}

function CalendarDialog({ id, open, onClose = () => {} }) {
  const Alert = useAlert();
  const [newData, setNewData] = useState({
    date: null,
    content: "",
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const [getCalendar, { loading }] = useLazyQuery(GET_CALENDAR, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ calendar }) {
      if (calendar) {
        changeData("content", calendar.content);
        changeData("date", calendar.date, true);
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  const [saveCalendar, { loading: saveCalendarLoading }] = useMutation(
    SAVE_CALENDAR,
    {
      onCompleted({ saveCalendar }) {
        if (saveCalendar) {
          Alert.alert("", "儲存成功", [
            {
              text: "確定",
              onPress: onClose("refetch"),
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "儲存失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );

  const [deleteCalendar, { loading: deleteCalendarLoading }] = useMutation(
    DELETE_CALENDAR,
    {
      onCompleted({ deleteCalendar }) {
        if (deleteCalendar) {
          return Alert.alert("", "刪除成功！", [
            {
              text: "確定",
              onPress: onClose("refetch"),
              type: "ok",
            },
          ]);
        } else {
          return Alert.alert("", "刪除失敗！", [
            {
              text: "確定",
              type: "ok",
            },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );

  function save() {
    if (!(newData.date || newData.content)) {
      return Alert.notice("行事曆未填寫完整！");
    }
    const calendarInput = {
      userId: Number(localStorage.getItem("@fullhouseUserId")),
      date: newData.date,
      content: newData.content,
    };
    if (id) {
      calendarInput.id = id;
    }
    saveCalendar({ variables: { calendarInput } });
  }

  useEffect(() => {
    if (id) getCalendar({ variables: { id } });
    else {
      changeData("date", null);
      changeData("content", "");
    }
  }, [id]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
      <LoadingModal
        loading={saveCalendarLoading || loading || deleteCalendarLoading}
      />
      <DialogTitle align="center">{`${id ? "編輯" : "新增"}活動`}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <Typography color="primary">時間</Typography>
            <DateInput
              value={newData.date}
              format="yyyy年MM月dd日"
              onChange={(v) => {
                changeData("date", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={12}>
            <Typography color="primary">內容</Typography>
            <TextInput
              multiline
              rows={5}
              value={newData.content}
              onChange={(v) => {
                changeData("content", v, true);
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={1} justify="center">
          <Grid item>
            <Button color="primary" variant="contained" onPress={save}>
              儲存
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="outlined"
              onPress={
                id
                  ? () => {
                      Alert.alert("", "確定刪除？", [
                        {
                          text: "確定",
                          onPress: () => {
                            deleteCalendar({ variables: { id } });
                          },
                          type: "ok",
                        },
                        { text: "取消", type: "cancel" },
                      ]);
                    }
                  : onClose
              }
            >
              {`${id ? "刪除" : "返回"}`}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
